"use strict";
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
// eslint gives error about missing key prop in tr, th, etc, but the key is part of the element's props */
/* eslint-disable react/jsx-key */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_table_1 = require("react-table");
const react_i18next_1 = require("react-i18next");
// User react-table to handle a few table functionalities like paging and filtering
const UsersTable = (props) => {
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, 
    // Get the state from the instance
    state: { pageIndex, pageSize, filters } } = (0, react_table_1.useTable)({
        columns: props.columns,
        data: props.data,
        initialState: { pageIndex: 0 },
        // We are handling our own pagination by the server queries, we don't have all the data loaded at once
        manualPagination: true,
        // Filters are also handled manually by the query to the server
        manualFilters: true,
        pageCount: props.pageCount
    }, react_table_1.useFilters, react_table_1.usePagination);
    // Listen for changes in pagination and filters and use the state to fetch our new data
    react_1.default.useEffect(() => {
        props.fetchData({ pageIndex, pageSize, filters });
    }, [props.fetchData, pageIndex, pageSize, filters]);
    return (react_1.default.createElement("div", { className: "userTable" },
        react_1.default.createElement("table", Object.assign({}, getTableProps()),
            react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => (react_1.default.createElement("th", Object.assign({}, column.getHeaderProps()),
                column.render('Header'),
                react_1.default.createElement("span", null, column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''),
                react_1.default.createElement("div", null, column.Filter ? column.render('Filter') : null)))))))),
            react_1.default.createElement("tbody", Object.assign({}, getTableBodyProps()),
                page.map((row) => {
                    prepareRow(row);
                    return (react_1.default.createElement("tr", Object.assign({}, row.getRowProps()), row.cells.map((cell) => {
                        return react_1.default.createElement("td", Object.assign({}, cell.getCellProps()), cell.render('Cell'));
                    })));
                }),
                react_1.default.createElement("tr", null, props.loading ? (
                // Use our custom loading state to show a loading indicator
                react_1.default.createElement("td", { colSpan: 10000 }, props.t('main:Loading'))) : (react_1.default.createElement("td", { colSpan: 10000 }, props.t('main:ShowingNofX', { n: page.length, x: props.itemCount })))))),
        react_1.default.createElement("div", { className: "pagination" },
            react_1.default.createElement("button", { onClick: () => gotoPage(0), disabled: !canPreviousPage }, '<<'),
            ' ',
            react_1.default.createElement("button", { onClick: () => previousPage(), disabled: !canPreviousPage }, '<'),
            ' ',
            react_1.default.createElement("button", { onClick: () => nextPage(), disabled: !canNextPage }, '>'),
            ' ',
            react_1.default.createElement("button", { onClick: () => gotoPage(pageCount - 1), disabled: !canNextPage }, '>>'),
            ' ',
            react_1.default.createElement("span", null, props.t('main:PageNofX', { n: pageIndex + 1, x: pageOptions.length })),
            react_1.default.createElement("span", null,
                "| ",
                props.t('main:GoToPage'),
                ":",
                ' ',
                react_1.default.createElement("input", { type: "number", defaultValue: pageIndex + 1, onChange: (e) => {
                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                        gotoPage(page);
                    }, style: { width: '100px' } })),
            ' ',
            react_1.default.createElement("select", { value: pageSize, onChange: (e) => {
                    setPageSize(Number(e.target.value));
                } }, [10, 20, 30, 40, 50].map((pageSize) => (react_1.default.createElement("option", { key: pageSize, value: pageSize }, props.t('main:ShowN', { n: pageSize }))))))));
};
exports.default = (0, react_i18next_1.withTranslation)('main')(UsersTable);
//# sourceMappingURL=UsersTable.js.map